"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFallbackLocale = void 0;
const localeObject_1 = require("./localeObject");
const localeFallback = {
    en: [localeObject_1.LocaleObject.fromAnyCode('en-US'), localeObject_1.LocaleObject.fromAnyCode('en-GB')],
    fr: [localeObject_1.LocaleObject.fromAnyCode('fr-FR'), localeObject_1.LocaleObject.fromAnyCode('fr-CA')],
};
/**
 * Fallback locales for each region independent locale.
 * For example, a story has en-CA en-AU and en-GB locales. As you can see there is no region independent locale.
 * We will use a list of possible fallbacks to determine region independent locale alias.
 * In the provided example the result will be en-GB since it is defined in the localeFallback list
 * If the list will be en-CA en-AU and en-US then the result will be en-US since it is the first one and hence takes precedence.
 */
function getFallbackLocale(langCode, availableLocales) {
    const fallbacks = localeFallback[langCode];
    if (!fallbacks) {
        return undefined;
    }
    return fallbacks.find((fallback) => Boolean(availableLocales.find((available) => available.isEqual(fallback))));
}
exports.getFallbackLocale = getFallbackLocale;
//# sourceMappingURL=getFallbackLocale.js.map